export const BACK_TO_RESULTS = "Back to results";

export const CUSTOMIZE = "Customize";
export const CUSTOMIZE_SUBTITLE = "Add or decline these options to continue";
